module.exports = __webpack_public_path__ + "media/img/favicon/site-0629f4181c3f848eaec09937a716bb36.webmanifest";